export let CommunicationChannel = /*#__PURE__*/function (CommunicationChannel) {
  CommunicationChannel["UNKNOWN_COMMUNICATION_CHANNEL"] = "UNKNOWN_COMMUNICATION_CHANNEL";
  CommunicationChannel["APP"] = "APP";
  CommunicationChannel["WHATSAPP"] = "WHATSAPP";
  CommunicationChannel["SMS"] = "SMS";
  CommunicationChannel["EMAIL"] = "EMAIL";
  CommunicationChannel["TELEGRAM"] = "TELEGRAM";
  CommunicationChannel["WEB"] = "WEB";
  CommunicationChannel["VOICE"] = "VOICE";
  CommunicationChannel["EXTERNAL_AGENT"] = "EXTERNAL_AGENT";
  CommunicationChannel["PHONE_CALL"] = "PHONE_CALL";
  CommunicationChannel["GMAIL_CONNECTOR"] = "GMAIL_CONNECTOR";
  CommunicationChannel["INSTAGRAM_CONNECTOR"] = "INSTAGRAM_CONNECTOR";
  CommunicationChannel["CALENDAR_MEETINGS"] = "CALENDAR_MEETINGS";
  CommunicationChannel["WHATSAPP_CONNECTOR"] = "WHATSAPP_CONNECTOR";
  return CommunicationChannel;
}({});
export let InterruptionPurpose = /*#__PURE__*/function (InterruptionPurpose) {
  InterruptionPurpose["UNKNOWN_PURPOSE"] = "UNKNOWN_PURPOSE";
  InterruptionPurpose["NEEDS_YOU"] = "NEEDS_YOU";
  InterruptionPurpose["DONE"] = "DONE";
  InterruptionPurpose["BROKE"] = "BROKE";
  InterruptionPurpose["NUDGE_MARKETING"] = "NUDGE_MARKETING";
  InterruptionPurpose["NUDGE_FOLLOWUP"] = "NUDGE_FOLLOWUP";
  InterruptionPurpose["NUDGE_ROUTINE"] = "NUDGE_ROUTINE";
  InterruptionPurpose["NUDGE_PEOPLE"] = "NUDGE_PEOPLE";
  InterruptionPurpose["NUDGE_CHECKIN"] = "NUDGE_CHECKIN";
  InterruptionPurpose["CHASE"] = "CHASE";
  return InterruptionPurpose;
}({});
export let SendAuthority = /*#__PURE__*/function (SendAuthority) {
  SendAuthority["UNKNOWN_AUTHORITY"] = "UNKNOWN_AUTHORITY";
  SendAuthority["LEGACY"] = "LEGACY";
  SendAuthority["LEDGER"] = "LEDGER";
  return SendAuthority;
}({});
export let RoutineUpdatesMode = /*#__PURE__*/function (RoutineUpdatesMode) {
  RoutineUpdatesMode["UNKNOWN_ROUTINE_UPDATES_MODE"] = "UNKNOWN_ROUTINE_UPDATES_MODE";
  RoutineUpdatesMode["EVERY_RUN"] = "EVERY_RUN";
  RoutineUpdatesMode["ON_CHANGE"] = "ON_CHANGE";
  RoutineUpdatesMode["ROUTINE_UPDATES_OFF"] = "ROUTINE_UPDATES_OFF";
  return RoutineUpdatesMode;
}({});
export let InterruptionOutcome = /*#__PURE__*/function (InterruptionOutcome) {
  InterruptionOutcome["UNKNOWN_OUTCOME"] = "UNKNOWN_OUTCOME";
  InterruptionOutcome["SENT"] = "SENT";
  InterruptionOutcome["JOINED"] = "JOINED";
  InterruptionOutcome["HELD"] = "HELD";
  InterruptionOutcome["FEED_ONLY"] = "FEED_ONLY";
  InterruptionOutcome["DENIED"] = "DENIED";
  InterruptionOutcome["SHADOW"] = "SHADOW";
  return InterruptionOutcome;
}({});
export let PushPlatform = /*#__PURE__*/function (PushPlatform) {
  PushPlatform["UNKNOWN_PUSH_PLATFORM"] = "UNKNOWN_PUSH_PLATFORM";
  PushPlatform["IOS"] = "IOS";
  PushPlatform["ANDROID"] = "ANDROID";
  return PushPlatform;
}({});
export let PushPermissionStatus = /*#__PURE__*/function (PushPermissionStatus) {
  PushPermissionStatus["UNKNOWN_PUSH_PERMISSION"] = "UNKNOWN_PUSH_PERMISSION";
  PushPermissionStatus["PUSH_GRANTED"] = "PUSH_GRANTED";
  PushPermissionStatus["PUSH_DENIED"] = "PUSH_DENIED";
  PushPermissionStatus["PUSH_NOT_DETERMINED"] = "PUSH_NOT_DETERMINED";
  PushPermissionStatus["PUSH_PROVISIONAL"] = "PUSH_PROVISIONAL";
  return PushPermissionStatus;
}({});
export let ClientSignalKind = /*#__PURE__*/function (ClientSignalKind) {
  ClientSignalKind["UNKNOWN_SIGNAL"] = "UNKNOWN_SIGNAL";
  ClientSignalKind["APP_OPEN"] = "APP_OPEN";
  ClientSignalKind["CONVERSATION_OPEN"] = "CONVERSATION_OPEN";
  ClientSignalKind["PUSH_TAP"] = "PUSH_TAP";
  ClientSignalKind["TASK_VIEWED"] = "TASK_VIEWED";
  ClientSignalKind["USER_REPLIED"] = "USER_REPLIED";
  ClientSignalKind["COMPLAINT_ESCALATED"] = "COMPLAINT_ESCALATED";
  ClientSignalKind["WA_TEMPLATE_CLAIM"] = "WA_TEMPLATE_CLAIM";
  ClientSignalKind["WA_TEMPLATE_RELEASE"] = "WA_TEMPLATE_RELEASE";
  ClientSignalKind["CHASE_ITEM_DONE"] = "CHASE_ITEM_DONE";
  ClientSignalKind["CHASE_ITEM_DISMISSED"] = "CHASE_ITEM_DISMISSED";
  ClientSignalKind["CHASE_ITEM_OPENED"] = "CHASE_ITEM_OPENED";
  ClientSignalKind["ASK_DISMISSED"] = "ASK_DISMISSED";
  return ClientSignalKind;
}({});
export let WhatsappTemplateClaimOutcome = /*#__PURE__*/function (WhatsappTemplateClaimOutcome) {
  WhatsappTemplateClaimOutcome["UNKNOWN_WHATSAPP_TEMPLATE_CLAIM_OUTCOME"] = "UNKNOWN_WHATSAPP_TEMPLATE_CLAIM_OUTCOME";
  WhatsappTemplateClaimOutcome["WA_TEMPLATE_CLAIMED"] = "WA_TEMPLATE_CLAIMED";
  WhatsappTemplateClaimOutcome["WA_TEMPLATE_HELD"] = "WA_TEMPLATE_HELD";
  WhatsappTemplateClaimOutcome["WA_TEMPLATE_RELEASED"] = "WA_TEMPLATE_RELEASED";
  return WhatsappTemplateClaimOutcome;
}({});
export let DeliveryOutcome = /*#__PURE__*/function (DeliveryOutcome) {
  DeliveryOutcome["UNKNOWN_DELIVERY_OUTCOME"] = "UNKNOWN_DELIVERY_OUTCOME";
  DeliveryOutcome["OUTCOME_ACCEPTED"] = "OUTCOME_ACCEPTED";
  DeliveryOutcome["OUTCOME_DELIVERED"] = "OUTCOME_DELIVERED";
  DeliveryOutcome["OUTCOME_READ"] = "OUTCOME_READ";
  DeliveryOutcome["OUTCOME_FAILED"] = "OUTCOME_FAILED";
  DeliveryOutcome["OUTCOME_UNKNOWN"] = "OUTCOME_UNKNOWN";
  return DeliveryOutcome;
}({});
export let ReservationOutcome = /*#__PURE__*/function (ReservationOutcome) {
  ReservationOutcome["UNKNOWN_RESERVATION_OUTCOME"] = "UNKNOWN_RESERVATION_OUTCOME";
  ReservationOutcome["RESERVED"] = "RESERVED";
  ReservationOutcome["RESERVATION_DENIED"] = "RESERVATION_DENIED";
  return ReservationOutcome;
}({});
export let OnboardingState = /*#__PURE__*/function (OnboardingState) {
  OnboardingState["UNKNOWN_ONBOARDING_STATE"] = "UNKNOWN_ONBOARDING_STATE";
  OnboardingState["ONBOARDING_NOT_STARTED"] = "ONBOARDING_NOT_STARTED";
  OnboardingState["ONBOARDING_GREETED"] = "ONBOARDING_GREETED";
  OnboardingState["ONBOARDING_ENGAGED"] = "ONBOARDING_ENGAGED";
  OnboardingState["ONBOARDING_COMPLETED"] = "ONBOARDING_COMPLETED";
  return OnboardingState;
}({});
export let PushReach = /*#__PURE__*/function (PushReach) {
  PushReach["UNKNOWN_PUSH_REACH"] = "UNKNOWN_PUSH_REACH";
  PushReach["PUSH_REACHABLE"] = "PUSH_REACHABLE";
  PushReach["PUSH_MUTED"] = "PUSH_MUTED";
  PushReach["PUSH_NONE"] = "PUSH_NONE";
  return PushReach;
}({});
export let WhatsappReach = /*#__PURE__*/function (WhatsappReach) {
  WhatsappReach["UNKNOWN_WHATSAPP_REACH"] = "UNKNOWN_WHATSAPP_REACH";
  WhatsappReach["WA_WINDOW_OPEN"] = "WA_WINDOW_OPEN";
  WhatsappReach["WA_TEMPLATE_ONLY"] = "WA_TEMPLATE_ONLY";
  WhatsappReach["WA_UNVERIFIED"] = "WA_UNVERIFIED";
  WhatsappReach["WA_NONE"] = "WA_NONE";
  return WhatsappReach;
}({});
export let ReminderChannel = /*#__PURE__*/function (ReminderChannel) {
  ReminderChannel["UNKNOWN_REMINDER_CHANNEL"] = "UNKNOWN_REMINDER_CHANNEL";
  ReminderChannel["REMINDER_APP"] = "REMINDER_APP";
  ReminderChannel["REMINDER_WHATSAPP"] = "REMINDER_WHATSAPP";
  ReminderChannel["REMINDER_EMAIL"] = "REMINDER_EMAIL";
  ReminderChannel["REMINDER_NONE"] = "REMINDER_NONE";
  return ReminderChannel;
}({});
export let ChaseCategory = /*#__PURE__*/function (ChaseCategory) {
  ChaseCategory["UNKNOWN_CHASE_CATEGORY"] = "UNKNOWN_CHASE_CATEGORY";
  ChaseCategory["CHASE_CATEGORY_MONEY"] = "CHASE_CATEGORY_MONEY";
  ChaseCategory["CHASE_CATEGORY_HEALTH"] = "CHASE_CATEGORY_HEALTH";
  ChaseCategory["CHASE_CATEGORY_PEOPLE"] = "CHASE_CATEGORY_PEOPLE";
  ChaseCategory["CHASE_CATEGORY_WORK"] = "CHASE_CATEGORY_WORK";
  ChaseCategory["CHASE_CATEGORY_OTHER"] = "CHASE_CATEGORY_OTHER";
  return ChaseCategory;
}({});
export let AbsenceBand = /*#__PURE__*/function (AbsenceBand) {
  AbsenceBand["UNKNOWN_ABSENCE_BAND"] = "UNKNOWN_ABSENCE_BAND";
  AbsenceBand["ABSENCE_PRESENT"] = "ABSENCE_PRESENT";
  AbsenceBand["ABSENCE_AWAY"] = "ABSENCE_AWAY";
  AbsenceBand["ABSENCE_GONE"] = "ABSENCE_GONE";
  AbsenceBand["ABSENCE_STOPPED"] = "ABSENCE_STOPPED";
  return AbsenceBand;
}({});
export let SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
  return SortOrder;
}({});
export let ChaseStakes = /*#__PURE__*/function (ChaseStakes) {
  ChaseStakes["UNKNOWN_CHASE_STAKES"] = "UNKNOWN_CHASE_STAKES";
  ChaseStakes["CHASE_LOW"] = "CHASE_LOW";
  ChaseStakes["CHASE_NORMAL"] = "CHASE_NORMAL";
  ChaseStakes["CHASE_HIGH"] = "CHASE_HIGH";
  ChaseStakes["CHASE_CRITICAL"] = "CHASE_CRITICAL";
  return ChaseStakes;
}({});
export let ChaseProvenance = /*#__PURE__*/function (ChaseProvenance) {
  ChaseProvenance["UNKNOWN_CHASE_PROVENANCE"] = "UNKNOWN_CHASE_PROVENANCE";
  ChaseProvenance["PROVENANCE_NOT_NEEDED"] = "PROVENANCE_NOT_NEEDED";
  ChaseProvenance["PROVENANCE_VERIFIED"] = "PROVENANCE_VERIFIED";
  ChaseProvenance["PROVENANCE_UNVERIFIED"] = "PROVENANCE_UNVERIFIED";
  ChaseProvenance["PROVENANCE_UNCHECKED"] = "PROVENANCE_UNCHECKED";
  return ChaseProvenance;
}({});